<img class=" grid_item" [src]="assetsImage" (error)="onImageError()">
<div class="no-img-bg" *ngIf="isImageInvalid">
    {{ assetName }}
</div>